const differentiators = [
  {
    icon: "ri-focus-3-line",
    title: "Projekt pod pozyskiwanie klientów",
    desc: "CTA, układ, formularze i przycisk Zadzwon w każdym miejscu, gdzie klient może zdecydować się na kontakt.",
    accent: "#1D4ED8",
    bg: "#EFF6FF",
  },
  {
    icon: "ri-map-pin-2-line",
    title: "Optymalizacja pod lokalne SEO",
    desc: "Twoja strona pojawia się w Google gdy ktoś szuka elektryka lub ogrodzeń w Twoim mieście.",
    accent: "#059669",
    bg: "#ECFDF5",
  },
  {
    icon: "ri-rocket-2-line",
    title: "Szybkie wdrożenie — 3–5 dni",
    desc: "Nie czekasz tygodniami. Od rozmowy do gotowej strony online w kilka dni roboczych.",
    accent: "#D97706",
    bg: "#FFFBEB",
  },
  {
    icon: "ri-tools-line",
    title: "Dopasowanie do branży",
    desc: "Strona dla elektryka wygląda jak strona elektryka, nie jak szablon kancelarii prawnej. Treści, układ i zdjęcia — wszystko branżowe.",
    accent: "#7C3AED",
    bg: "#F5F3FF",
  },
];

const SolutionSection = () => {
  return (
    <section className="py-20 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="inline-block text-[#1D4ED8] text-sm font-semibold tracking-wide uppercase mb-4">
            Rozwiązanie
          </span>
          <h2 className="text-3xl lg:text-4xl font-extrabold text-[#0F172A] mb-5 leading-tight">
            Co robię inaczej
          </h2>
          <p className="text-[#64748B] text-lg leading-relaxed">
            Twoja strona ma przynosić klientów, nie tylko wyglądać. Każda decyzja projektowa podporządkowana jest jednemu celowi — więcej telefonów.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6">
          {differentiators.map((d) => (
            <div
              key={d.title}
              className="rounded-2xl border border-gray-100 bg-white p-6 flex flex-col gap-4 hover:-translate-y-1 transition-transform"
            >
              <div
                className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ backgroundColor: d.bg }}
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className={`${d.icon} text-xl`} style={{ color: d.accent }}></i>
                </div>
              </div>
              <div>
                <h3 className="font-bold text-[#0F172A] text-base mb-2 leading-snug">{d.title}</h3>
                <p className="text-[#64748B] text-sm leading-relaxed">{d.desc}</p>
              </div>
              <div className="mt-auto pt-2 border-t border-gray-50">
                <div className="w-8 h-0.5 rounded-full" style={{ backgroundColor: d.accent }}></div>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom banner */}
        <div className="mt-10 bg-[#F8FAFF] border border-[#DBEAFE] rounded-2xl p-6 lg:p-8 flex flex-col lg:flex-row items-center gap-5 text-center lg:text-left">
          <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#EFF6FF] flex-shrink-0">
            <div className="w-7 h-7 flex items-center justify-center">
              <i className="ri-line-chart-line text-2xl text-[#1D4ED8]"></i>
            </div>
          </div>
          <div className="flex-1">
            <p className="font-bold text-[#0F172A] text-lg">
              Wynik, który mnie interesuje: ile razy klient do Ciebie zadzwonił
            </p>
            <p className="text-[#64748B] text-sm mt-1">
              Nie certyfikaty, nie nagrody, nie portfolio. Czy strona generuje zapytania — to jest miara sukcesu.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
